import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import './CollegeContributeLanding.scss';
import CollegeContributeSteps from '../CollegeContributeSteps/CollegeContributeSteps';
import ContributeDisclaimerNote from '../ContributeDisclaimerNote/ContributeDisclaimerNote';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { isCollegeContribute } from '../../../utils/transactions-util';
import { moduleActions } from '../../../redux/modules';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  DOB_FAILURE,
  executingCollegeContributeMessages,
  FOREIGN_ADDRESS,
  loadingBuySellCollegeMessages,
  MD529_DECOMMISSION,
  NOT_RETAIL_CLIENT,
  PURCHASE_FAILURE,
  TIMEOUT,
} from '../../../settings/settings';
import BalancesAsOfToolTip from '../../Shared/BalancesAsOfToolTip/BalancesAsOfToolTip';
import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import { appendBasePath } from '../../../utils/nav.utils';
import { hasValue } from '../../../utils/utils';
import {
  didPersonalInformationFail,
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import If from '../../Shared/If/If';
import { getCollegeTypeCount } from '../../../redux/modules/productTypes/productType.selectors';

export class CollegeContributeLanding extends Component {
  componentDidUpdate(prevProps) {
    this.checkNeedPushConfirm(prevProps);
  }

  checkNeedPushConfirm(prevProps) {
    const {
      executeCollegeContribute: { isLoaded, transactions },
      history,
    } = this.props;
    const {
      executeCollegeContribute: { isLoading: wasLoading },
    } = prevProps;

    if (wasLoading && isLoaded && hasValue(transactions)) {
      history.push(appendBasePath('/college/contribute/confirm'));
    }
  }

  render() {
    const {
      isIFrame,
      customerWebViewEnabled,
      isSalesforceRep,
      applicationData,
      dateOfBirth,
      hasMD529OnlyCount,
      personalInfoFailed,
      executeCollegeContribute,
      isAddressAvailable,
      isNotForeignAddress,
      isCorporateAccountType,
      personalInformation: { data: personalData },
    } = this.props;
    const isLoaderVisible =
      applicationData.isLoading || executeCollegeContribute.isLoading;
    const { retailEnabled } = personalData;
    const message = applicationData.isLoading
      ? loadingBuySellCollegeMessages
      : executeCollegeContribute.isLoading
      ? executingCollegeContributeMessages
      : '';
    const getError = () => {
      if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
        return {
          type: DOB_FAILURE,
          hasError: true,
        };
      }
      if (!personalInfoFailed && !isNotForeignAddress) {
        return {
          type: FOREIGN_ADDRESS,
          hasError: true,
        };
      }
      if (applicationData.hasFailed) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (!retailEnabled) {
        return {
          type: NOT_RETAIL_CLIENT,
          hasError: true,
        };
      }
      if (executeCollegeContribute.timeout) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      if (executeCollegeContribute.hasFailed) {
        return {
          type: PURCHASE_FAILURE,
          hasError: true,
        };
      }
      if (!isAddressAvailable) {
        return {
          type: ADDRESS_INCOMPLETE,
          hasError: true,
        };
      }
      if (hasMD529OnlyCount === 0) {
        return {
          type: MD529_DECOMMISSION,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };
    return (
      <CollegeBrandingContainer>
        <FullPageLoader
          isVisible={isLoaderVisible}
          hasError={getError().hasError}
          errorType={getError().type}
          messages={message}
        />
        <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
          <StepsPageBackground />
        </If>
        <div className="container">
          <CollegeContributeSteps />
          <BalancesAsOfToolTip />
          <hr />
          <div className="college-contribute-disclaimer-note">
            <ContributeDisclaimerNote />
          </div>
        </div>
        <If test={isCollegeContribute()}>
          <p className="container">2819645</p>
        </If>
      </CollegeBrandingContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { applicationData, executeCollegeContribute } = state;
  return {
    isIFrame: isEmbeddedInIFrame(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    applicationData,
    executeCollegeContribute,
    dateOfBirth: getDateOfBirth(state),
    hasMD529OnlyCount: getCollegeTypeCount(state),
    personalInfoFailed: didPersonalInformationFail(state),
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CollegeContributeLanding);
